import { Controller } from "@hotwired/stimulus"

// Copies the text content of `data-clipboard-source-target` to the clipboard
// when the action fires. Briefly swaps the button label to "Copiado!".
//
// A11y: a label muda visualmente E anuncia via live region (aria-live="polite"
// no próprio label). Como o textContent muda, o SR lê a nova string.
// `copiedLabel` vem do data-value pra suportar i18n (passado pelo partial).
export default class extends Controller {
  static targets = ["source", "label"]
  static values  = { copiedLabel: { type: String, default: "Copied!" } }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.innerText.trim())
      const previous = this.labelTarget.textContent
      this.labelTarget.textContent = this.copiedLabelValue
      // Garante anúncio ao SR (em alguns browsers o textContent change só
      // dispara live region se a região existir antes; o setAttribute força).
      this.labelTarget.setAttribute("aria-live", "polite")
      setTimeout(() => (this.labelTarget.textContent = previous), 1200)
    } catch (err) {
      console.error("Clipboard copy failed", err)
    }
  }
}
